import {Component} from '@angular/core';
import {ICellEditorAngularComp, ICellRendererAngularComp} from 'ag-grid-angular/main';
import * as _ from 'lodash';

@Component({
  selector: 'app-subscriber-titles-renderer-cell',
  templateUrl: './popover.component.html'
})
export class SubscriberTitlesPopoverComponent implements ICellEditorAngularComp, ICellRendererAngularComp {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  // demonstrates how you can do "inline" editing of a cell
  onChange($event) {
  }

  getValue() {
  }

  getClass() {

  }

  getPopoverText() {
    return this.getPopoverTemplate();
  }

  refresh(params: any): boolean {
    return false;
  }

  getPopoverTemplate() {

    const titles = [];
    if (this.params.value[0].disciplineQualifications) {
      _.map(this.params.value, (card) => {
        _.map(card.disciplineQualifications, (elem) => {
          titles.push(elem.discipline.description + ' - ' + elem.qualification.description);
        });
      });
    } else {
      _.map(this.params.value, (elem) => {
        titles.push(elem.disciplinaTitolo + ' - ' + elem.qualificaTitolo);
      });
    }

    let template = '';
    titles.forEach(title => {
      template += '<div><span class="mr-1">' + title + '</div>';
    });
    return template;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ag-grid-custom-components/subscriber-titles-popover/popover.components.ts